import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Slider
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';
import copyToClipboard from '../utils/copyToClipboard';

interface Props extends WithTranslation
{
}
interface State
{
    allCorners,
    topLeftCorner,
    topRightCorner,
    bottomLeftCorner,
    bottomRightCorner,
    panelColor,
    backgroundColor,
}

/**
 * @author Germán Martínez
 */
class RouteToolsBorderRadius extends React.Component<Props,State>
{
    state =
    {
        allCorners: 0,
        topLeftCorner: 0,
        topRightCorner: 0,
        bottomLeftCorner: 0,
        bottomRightCorner: 0,
        panelColor: '',
        backgroundColor: '',
    }

    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/box-shadow'>{t('titles.toolsBorderRadiusGenerator')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsBorderRadiusGenerator')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBorderRadius.allCornersLabel')}</label>
                        <label className="ml-auto">{this.state.allCorners}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.allCorners}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            allCorners: newValue,
                            topLeftCorner: newValue,
                            topRightCorner: newValue,
                            bottomLeftCorner: newValue,
                            bottomRightCorner: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBorderRadius.topLeftCornerLabel')}</label>
                        <label className="ml-auto">{this.state.topLeftCorner}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.topLeftCorner}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            topLeftCorner: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBorderRadius.topRightCornerLabel')}</label>
                        <label className="ml-auto">{this.state.topRightCorner}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.topRightCorner}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            topRightCorner: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBorderRadius.bottomLeftCornerLabel')}</label>
                        <label className="ml-auto">{this.state.bottomLeftCorner}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.bottomLeftCorner}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            bottomLeftCorner: newValue,
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolBorderRadius.bottomRightCornerLabel')}</label>
                        <label className="ml-auto">{this.state.bottomRightCorner}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={200}
                        value={this.state.bottomRightCorner}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            bottomRightCorner: newValue,
                        });
                    }}/>
                </FormGroup>
            </div>

            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <input className="form-control" value={this.fullFormatBorderRadius()} readOnly={true} />
                        <span className="mini-button ml-1" onClick={() =>
                        {
                            copyToClipboard(this.fullFormatBorderRadius());
                        }}>
                            <i className="icon-clipboard"></i>
                        </span>
                    </div>
                </FormGroup>
                <div className="simple-test-box-panel" style={{background: this.state.backgroundColor}}>
                    <div style={{
                        borderRadius: this.formatBorderRadius(),
                        background: this.state.panelColor,
                    }}>
                    </div>
                </div>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    private formatBorderRadius()
    {
        return ''
                + this.state.topLeftCorner + 'px '
                + this.state.topRightCorner + 'px '
                + this.state.bottomRightCorner + 'px '
                + this.state.bottomLeftCorner + 'px'
                ;
    }

    private fullFormatBorderRadius()
    {
        return 'border-radius: ' + this.formatBorderRadius() + ';';
    }
};
export default withTranslation('common')(RouteToolsBorderRadius);
